import { api } from '@/src/shared/lib/api'

export async function paypalSubscriptionCapturePost<ApiResponse>(id: string) {
  const url = api.appURL(`paypal/subscription/${id}/capture`)
  const response = await api.post<ApiResponse>(url, {}, {})
  return api.parseRespone<ApiResponse>(response)
}
